import LoginBtn from './LoginBtn'
import LanguageBtn from './LanguageBtn'
import './Header.css'
import logo from './img/logo.png'
import logoWebp from './img/logo.webp'
const Header = ({signStatus, getLanguage}) => {
  return (
    <div className="main-navbar">         
      <h1 className='main-title'>
        <picture>
          <source srcSet={logoWebp} type="image/webp" />
          <img
            src={logo}
            alt="Логотип"
            className="main-logo"
            width={150}
            height={50}
            decoding="async"
          />
        </picture>
        {/* LOW COST TV */}
      </h1>
      <div className="nav-actions">
        <LanguageBtn getLanguage={getLanguage}/>
        <LoginBtn signStatus={signStatus}/>
      </div>
    </div>
  );
};
export default Header;